export const MONALBUMPHOTO_ARCHIVE_REQUESTED = "MONALBUMPHOTO_ARCHIVE_REQUESTED";
export const MONALBUMPHOTO_ARCHIVE_RECEIVED = "MONALBUMPHOTO_ARCHIVE_RECEIVED";
export const MONALBUMPHOTO_ARCHIVE_REQUEST_FAILED = "MONALBUMPHOTO_ARCHIVE_REQUEST_FAILED";

export const requestMonAlbumPhotoArchive = () => ({ type: MONALBUMPHOTO_ARCHIVE_REQUESTED });
export const receiveMonAlbumPhotoArchive = payload => ({ type: MONALBUMPHOTO_ARCHIVE_RECEIVED, payload });
